import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px",
  "Xdata-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10",
  style: {"background-image":"url('media/misc/pattern-1.jpg')"}
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-white fw-bold mb-3" }, "Quick Links"),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-success py-2 px-3" }, "25 pending tasks")
], -1)
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = {
  href: "#",
  class: "d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end border-bottom"
}
const _hoisted_6 = { class: "svg-icon svg-icon-3x svg-icon-success mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold text-gray-800 mb-0" }, "Accounting", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-gray-400" }, "eCommerce", -1)
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = {
  href: "#",
  class: "d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3x svg-icon-success mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold text-gray-800 mb-0" }, "Administration", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-gray-400" }, "Console", -1)
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = {
  href: "#",
  class: "d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end"
}
const _hoisted_16 = { class: "svg-icon svg-icon-3x svg-icon-success mb-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold text-gray-800 mb-0" }, "Projects", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-gray-400" }, "Pending Tasks", -1)
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  href: "#",
  class: "d-flex flex-column flex-center h-100 p-6 bg-hover-light"
}
const _hoisted_21 = { class: "svg-icon svg-icon-3x svg-icon-success mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold text-gray-800 mb-0" }, "Customers", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-gray-400" }, "Latest cases", -1)
const _hoisted_24 = { class: "py-2 text-center border-top" }
const _hoisted_25 = {
  href: "#",
  class: "btn btn-color-gray-600 btn-active-color-primary"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" View All ")
const _hoisted_27 = { class: "svg-icon svg-icon-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin009.svg" })
          ]),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com010.svg" })
          ]),
          _hoisted_12,
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs042.svg" })
          ]),
          _hoisted_17,
          _hoisted_18
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("a", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin006.svg" })
          ]),
          _hoisted_22,
          _hoisted_23
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("a", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("span", _hoisted_27, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
        ])
      ])
    ])
  ]))
}